import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

import { Button, Card, Col, Row } from 'antd'
import moment from 'moment'

import { CustomBreadcrumb } from '../../../../components/CustomBreadcrumb/CustomBreadcrumb'
import { RULES, validRule } from '../../../../constants/Entitlements'
import { api, request } from '../../../../util/handlerRequestUtil'
import { getMessage } from '../../../../util/IntlMessages'
import { isAdmin } from '../../../../util/profiles'
import ActionsTimeline from './ActionsTimeline'

import './actionStyles.css'

const STYLES = {
  resetMargin: { margin: '0 0 0 0' },
  pageBottomMargin: { paddingBottom: '0.5rem' },
  flexBarFullWidth: {
    flex: 1,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
}

const ShowTimeline = function ({ match, history }) {
  const currentUser = useSelector((state) => state.auth.auth)
  const [timeline, setTimeline] = useState([])
  const [formattedData, setFormattedData] = useState({})
  const [searchParams, setSearchParams] = useState({})
  const [pageState, setPageState] = useState(0)

  // Created component
  useEffect(() => {
    const hasAccess = validRule(RULES.ACTION) // Não deixa acessar a tela
    if (!hasAccess) {
      return history.push('/home')
    }

    listActions({ page: 0 })
  }, [])

  const canShowLoadMore = useMemo(() => Object.keys(formattedData).length && isAdmin(), [formattedData, currentUser])

  const listActions = async (params) => {
    let queryParams = params || searchParams
    setSearchParams(queryParams)

    const { actions, page } = await request(api.getTimeline(queryParams))

    handleApiResponse(actions, page)
  }

  const handleApiResponse = (actions, page) => {
    let groups

    if (canShowLoadMore && parseInt(page) !== 0) {
      groups = groupActionByKey([...timeline, ...actions])
      setTimeline((state) => [...state, ...actions])
    } else {
      groups = groupActionByKey(actions)
      setTimeline(actions)
    }

    const sorted = sortTimelineGroups(groups)
    setPageState(parseInt(page))
    setFormattedData(sorted)
  }

  const groupActionByKey = (actions = []) => {
    return actions.reduce((acc, action) => {
      acc[action.key] = acc[action.key] || []
      acc[action.key].push(action)
      return acc
    }, {})
  }

  function sortTimelineGroups(groups = {}) {
    let ordered = {}

    Object.keys(groups)
      .sort(function (a, b) {
        return moment(a).toDate() - moment(b).toDate()
      })
      .forEach(function (key) {
        ordered[key] = groups[key]
      })

    return ordered
  }

  const hasAccess = validRule(RULES.ACTION)

  const renderHeader = () => (
    <div style={STYLES.pageBottomMargin}>
      <div style={STYLES.flexBarFullWidth}>
        <CustomBreadcrumb match={match} history={history} />
        {hasAccess && (
          <Button className="bgPrimary button-action" type="primary" onClick={() => history.push('/actions/create')}>
            {getMessage('createAction')}
          </Button>
        )}
      </div>
    </div>
  )

  const renderShowMoreButton = useMemo(
    () =>
      canShowLoadMore && (
        <div className="load-more-wrap">
          <Button className="load-more-btn" onClick={() => listActions({ ...searchParams, page: pageState + 1 })}>
            Carregar Mais
          </Button>
        </div>
      ),
    [canShowLoadMore, setSearchParams, pageState, timeline]
  )

  return (
    <>
      {renderHeader()}
      <Card className="ant-card gx-card ant-card-bordered">
        <Row type="flex" justify="start">
          <Col span={24}>
            <ActionsTimeline data={formattedData} onLoad={listActions} history={history} />

            {renderShowMoreButton}
          </Col>
        </Row>
      </Card>
    </>
  )
}

export default ShowTimeline
